<div class="navigation" *ngIf="position === 'side'">
  <button [disabled]="navigationEvent?.isBeginning" (click)="navigation('prev')" [class]="classPrev" class="nav btn btn-outline-primary ml-0 mr-0 ltr:xl:-ml-[50px] rtl:xl:-mr-[50px]">
    <svg-icon class="rtl:hidden btn-icon" src="@assets/images/icons/arrow-left.svg"></svg-icon>
    <svg-icon class="ltr:hidden btn-icon" src="@assets/images/icons/arrow-right.svg"></svg-icon>
  </button>
  <button [disabled]="navigationEvent?.isEnd" (click)="navigation('next')" [class]="classNext" class="nav btn btn-outline-primary ml-0 mr-0 ltr:xl:-mr-[50px] rtl:xl:-ml-[50px]">
    <svg-icon class="rtl:hidden btn-icon" src="@assets/images/icons/arrow-right.svg"></svg-icon>
    <svg-icon class="ltr:hidden btn-icon" src="@assets/images/icons/arrow-left.svg"></svg-icon>
  </button>
</div>

<div class="navigation-top" *ngIf="position === 'top'">
  <button [disabled]="navigationEvent?.isBeginning" (click)="navigation('prev')" [class]="classPrev" class="nav btn btn-outline-primary">
    <svg-icon class="rtl:hidden btn-icon" src="@assets/images/icons/arrow-left.svg"></svg-icon>
    <svg-icon class="ltr:hidden btn-icon" src="@assets/images/icons/arrow-right.svg"></svg-icon>
  </button>
  <button [disabled]="navigationEvent?.isEnd" (click)="navigation('next')" [class]="classNext" class="nav btn btn-outline-primary">
    <svg-icon class="rtl:hidden btn-icon" src="@assets/images/icons/arrow-right.svg"></svg-icon>
    <svg-icon class="ltr:hidden btn-icon" src="@assets/images/icons/arrow-left.svg"></svg-icon>
  </button>
</div>
